function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M9.43 22a8.43 8.43 0 100-16.86 8.43 8.43 0 000 16.86z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.496 16.38s1.311 1.124 3.934 1.124c2.622 0 3.934-1.124 3.934-1.124",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.62 13.008a1.124 1.124 0 100-2.248 1.124 1.124 0 000 2.248zM12.24 13.008a1.124 1.124 0 100-2.248 1.124 1.124 0 000 2.248z",
  fill: "currentColor"
});
var _ref4 = /*#__PURE__*/React.createElement("mask", {
  id: "reactions_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 11,
  y: 0,
  width: 12,
  height: 12,
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 0h12v12H11z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2 9.2a.8.8 0 001.6 0V6.8h2.4a.8.8 0 000-1.6h-2.4V2.8a.8.8 0 00-1.6 0v2.4h-2.4a.8.8 0 100 1.6h2.4v2.4z"
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2 9.2a.8.8 0 001.6 0V6.8h2.4a.8.8 0 000-1.6h-2.4V2.8a.8.8 0 00-1.6 0v2.4h-2.4a.8.8 0 100 1.6h2.4v2.4z",
  fill: "currentColor"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8 6.8v-2h-2v2h2zm0-1.6h-2v2h2v-2zM17 2v2-2zm-.8 3.2v2h2v-2h-2zm0 1.6h2v-2h-2v2zM17 8a1.2 1.2 0 011.2 1.2h-4A2.8 2.8 0 0017 12V8zm-1.2 1.2A1.2 1.2 0 0117 8v4a2.8 2.8 0 002.8-2.8h-4zm0-2.4v2.4h4V6.8h-4zm4.4-2h-2.4v4h2.4v-4zM19 6a1.2 1.2 0 011.2-1.2v4A2.8 2.8 0 0023 6h-4zm1.2 1.2A1.2 1.2 0 0119 6h4a2.8 2.8 0 00-2.8-2.8v4zm-2.4 0h2.4v-4h-2.4v4zm-2-4.4v2.4h4V2.8h-4zM17 4a1.2 1.2 0 01-1.2-1.2h4A2.8 2.8 0 0017 0v4zm1.2-1.2A1.2 1.2 0 0117 4V0a2.8 2.8 0 00-2.8 2.8h4zm0 2.4V2.8h-4v2.4h4zm-4.4 2h2.4v-4h-2.4v4zM15 6a1.2 1.2 0 01-1.2 1.2v-4A2.8 2.8 0 0011 6h4zm-1.2-1.2A1.2 1.2 0 0115 6h-4a2.8 2.8 0 002.8 2.8v-4zm2.4 0h-2.4v4h2.4v-4zm2 4.4V6.8h-4v2.4h4z",
  fill: "#fff",
  mask: "url(#reactions_svg__a)"
});
function SvgReactions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default SvgReactions;